import _ from "lodash";
import {
  SCORE,
  CATEGORY_PLACEHOLDER,
  GRADE,
  CATEGORY_SCORE,
  CATEGORY_GRADE,
} from "Constants/stringConstants";
import { getOrganizationConstantsFromCache } from "modules/CommonGraphqlHelpers";

const getCriteriaTypeAndSubType = ({ criteriaTypes }) => {
  const subTypeToFilter = [];
  const criteriaTypeToFilter = [];
  _.forEach(criteriaTypes, criteriaType => {
    switch (criteriaType) {
      case CATEGORY_SCORE: {
        subTypeToFilter.push(SCORE);
        criteriaTypeToFilter.push(CATEGORY_PLACEHOLDER);
        break;
      }
      case CATEGORY_GRADE: {
        subTypeToFilter.push(GRADE);
        criteriaTypeToFilter.push(CATEGORY_PLACEHOLDER);
        break;
      }
      default: {
        criteriaTypeToFilter.push(criteriaType);
      }
    }
  });
  return { subTypeToFilter, criteriaTypeToFilter };
};

const getAcademicCriteriaSetsForNomenclature = ({
  academicCriteriaSets,
  organizationId,
  curriculumProgramId,
  criteriaTypes,
}) => {
  let updatedAcademicCriteriaSets = academicCriteriaSets;

  if (_.isEmpty(updatedAcademicCriteriaSets)) {
    const organizationConstants = getOrganizationConstantsFromCache(
      organizationId
    );

    updatedAcademicCriteriaSets = _.get(
      organizationConstants,
      "academicCriteriaSets",
      []
    );
  }
  const { subTypeToFilter, criteriaTypeToFilter } = getCriteriaTypeAndSubType({
    criteriaTypes,
  });

  return _.filter(
    updatedAcademicCriteriaSets,
    ({ criteriaType, subType, curriculumProgram, curriculumProgramId: id }) => {
      const criteriaSetCheck = _.includes(criteriaTypeToFilter, criteriaType);
      const subTypeCheck =
        criteriaType == CATEGORY_PLACEHOLDER
          ? _.includes(subTypeToFilter, subType)
          : true;
      const curriculumProgramCheck = _.isEqual(
        _.isNil(curriculumProgram) ? id : _.get(curriculumProgram, "id", ""),
        curriculumProgramId
      );

      return curriculumProgramCheck && criteriaSetCheck && subTypeCheck;
    }
  );
};

export const getCriteriaSetLabels = ({
  organizationId,
  curriculumProgramId,
  criteriaTypes,
  academicCriteriaSets = [],
}) => {
  const updatedAcademicCriteriaSets = getAcademicCriteriaSetsForNomenclature({
    academicCriteriaSets,
    organizationId,
    curriculumProgramId,
    criteriaTypes,
  });

  return _.reduce(
    updatedAcademicCriteriaSets,
    (acc, { criteriaType, label, subType }) => {
      let criteriaKey;
      switch (criteriaType) {
        case CATEGORY_PLACEHOLDER: {
          switch (subType) {
            case SCORE: {
              criteriaKey = CATEGORY_SCORE;
              break;
            }
            case GRADE: {
              criteriaKey = CATEGORY_GRADE;
              break;
            }
          }
          break;
        }
        default: {
          criteriaKey = criteriaType;
        }
      }
      acc[criteriaKey] = label;
      return acc;
    },
    {}
  );
};
